/* eslint-disable jsx-a11y/label-has-associated-control */
import cx from 'classnames';
import React, { useEffect, useState } from 'react';
import { RD_COMPONENTS } from '../../_utils';
import { Typography } from '../../typography';
import { InputText } from '../input-text';
import styles from './input-file.module.scss';
export const InputFile = ({ className, placeholder, value = '', hasError = false, helperText, label = 'Upload', disabled, onChange, validation, ...restProps }) => {
    const [selectedFiles, setSelectedFiles] = useState(value);
    // errText is set to helperText or to validation error message if validation check fails.
    const [errText, setErrText] = useState(helperText || '');
    // isErrorPresent is set to true when either parent sets it to true using hasError prop or when the validation check fails.
    const [isErrorPresent, setIsErrorPresent] = useState(hasError);
    const containerClassNames = cx(className, styles.container);
    useEffect(() => {
        setSelectedFiles(value);
    }, [value]);
    const handleChange = (event) => {
        const files = event.target.files || [];
        const fileNamesArr = [];
        let fileName = '';
        let isValidationError = false;
        let validationErrMsg = null;
        if (files.length) {
            for (let i = 0; i < files.length; i++) {
                const { size, name } = files[i];
                const currentFileSizeinKbs = size / 1000;
                const curentFileExtension = name.substr(name.lastIndexOf('.') + 1, name.length);
                if (validation) {
                    const { maxFileSizeValidation, fileTypesValidation, } = validation;
                    const isFileTypesValidationError = fileTypesValidation &&
                        !fileTypesValidation.allowedExtensions.includes(curentFileExtension);
                    const isMaxSizeValidationError = maxFileSizeValidation &&
                        currentFileSizeinKbs > maxFileSizeValidation.maxSize;
                    if (isFileTypesValidationError) {
                        isValidationError = true;
                        validationErrMsg = fileTypesValidation.errMessage;
                    }
                    else if (isMaxSizeValidationError) {
                        isValidationError = true;
                        validationErrMsg = maxFileSizeValidation.errMessage;
                    }
                }
                fileNamesArr.push(name);
            }
            fileName =
                fileNamesArr.length === 1
                    ? fileNamesArr[0]
                    : `${fileNamesArr[0]} + ${fileNamesArr.length - 1}`;
        }
        setSelectedFiles(fileName);
        setIsErrorPresent(isValidationError);
        const finalErrorText = validationErrMsg || helperText || '';
        setErrText(finalErrorText);
        if (onChange && !isValidationError) {
            onChange(event, files);
        }
    };
    return (React.createElement("div", { "data-radiant-v2": true, className: containerClassNames },
        React.createElement("div", { className: styles.inputContainer },
            React.createElement(InputText, { ariaLabel: placeholder || 'Select File', hasError: isErrorPresent, helperText: errText, placeholder: placeholder || 'Select File', disabled: disabled, value: selectedFiles, readOnly: true })),
        React.createElement("label", { className: styles.label },
            React.createElement(Typography, { variant: "body-normal" }, label),
            React.createElement("input", { type: "file", className: styles.inputFile, disabled: disabled, onChange: handleChange, accept: validation && validation.fileTypesValidation
                    ? `.${validation.fileTypesValidation.allowedExtensions.join(',.')}`
                    : '', ...restProps }))));
};
InputFile.RD_COMPONENT = RD_COMPONENTS.INPUT_FILE;
//# sourceMappingURL=input-file.js.map